module.exports = __webpack_public_path__ + "img/map_resizer.04c4c74b.svg";